import {
  hasSections,
  isActive,
  isExtractionPhase,
} from '../config/brandLifecycleConfig'

// The five faces of the Drafts tab.
export const DRAFTS_SCREEN = Object.freeze({
  // Nothing has been extracted — the work is still on the Upload tab.
  EMPTY: 'EMPTY',
  // Extraction is running, has failed, or has finished and is waiting for the
  // reviewer to open what came out of it.
  PROGRESS: 'PROGRESS',
  LOADING: 'LOADING',
  REVIEW: 'REVIEW',
  // The brand is live; its sections are on the Brand Profile tab.
  ACTIVE: 'ACTIVE',
})

/*
 * `brand_lifecycle_status` decides which face is shown, and it alone:
 *
 *   EXTRACTION_IN_PROGRESS  the progress screen, until the reviewer opens the
 *                           sections from it
 *   IN_REVIEW and beyond    the sections, straight away — someone arriving
 *                           from the landing page never sees the progress
 *                           screen for work that has already finished
 *   anything else           nothing to show
 *
 * The extraction job's own status never appears here. It answers a narrower
 * question — whether the Review button is live yet — inside EXTRACTION_IN_PROGRESS.
 */
export const getDraftsScreen = ({
  isReviewLoading = false,
  isReviewOpen = false,
  lifecycleStatus = '',
} = {}) => {
  if (isActive(lifecycleStatus)) return DRAFTS_SCREEN.ACTIVE
  if (isExtractionPhase(lifecycleStatus) && !isReviewOpen) {
    return DRAFTS_SCREEN.PROGRESS
  }
  if (!hasSections(lifecycleStatus) && !isReviewOpen) return DRAFTS_SCREEN.EMPTY
  return isReviewLoading ? DRAFTS_SCREEN.LOADING : DRAFTS_SCREEN.REVIEW
}
